"use client"

import React, {useEffect} from 'react';
import {Button, ButtonGroup} from "@heroui/button";
import {Progress} from "@heroui/progress";
import {DatePicker} from "@heroui/date-picker";
import {parseAbsoluteToLocal} from "@internationalized/date";


let intervalRef = null;

export function App() {

    let [date, setDate] = React.useState(null);
    let [diff, setDiff] = React.useState(0);
    let [goal, setGoal] = React.useState(0);


    useEffect(() => {
        if (date === null) {
            setDate(
                parseAbsoluteToLocal((localStorage.date ? new Date(+localStorage.date) : new Date()).toISOString())
            )
        }
    }, [date]);

    useEffect(() => {
        setGoal(localStorage.goal ? +localStorage.goal : 8);
    }, []);

    useEffect(() => {
        if (!date) return;
        localStorage.date = +date.toDate();
        localStorage.goal = goal;
    }, [date, goal]);


    useEffect(() => {
        if (!date) return;
        clearInterval(intervalRef);
        setDiff(Math.round((+new Date() - +date.toDate()) / 1000))
        intervalRef = setInterval(() => {
            setDiff(Math.round((+new Date() - +date.toDate()) / 1000))
        }, 1000)

    }, [date]);

    useEffect(() => {
        if (!date) return;
        const updateTitle = () => {
            document.title = formatSecondsToTimeNoSeconds(Math.round((+new Date() - +date.toDate()) / 1000));
        };
        setTimeout(updateTitle, 1000);
        const titleInterval = setInterval(updateTitle, 60 * 1000);
        return () => clearInterval(titleInterval);
    }, [date]);

    if(!date) return null

    return (
        <div className={"flex flex-col gap-10 px-5"}>
            <h2 className={"text-9xl text-center"}>
                {formatSecondsToTime(diff)}
            </h2>
            <div className={"flex"}>
                <Progress  label={((diff / (60 * 60) / goal) * 100).toFixed(2)+"%"} aria-label="Loading..." size="lg" value={((diff / (60 * 60) / goal) * 100)}/>
            </div>
            <div className={"flex flex-col md:flex-row items-center gap-5 justify-center"}>
                <DatePicker value={date} onChange={setDate} className=" w-full md:w-auto" granularity="second"
                            label="Start time"/>

                <ButtonGroup fullWidth>

                    {
                        [8, 16, 24, 48, 72].map(hours => (
                            <Button color={goal === hours ? "primary" : "default"} key={hours}
                                    onPress={() => setGoal(hours)}>{hours}h</Button>
                        ))
                    }
                </ButtonGroup>
                <Button className={"w-full md:w-auto"} onPress={() => setDate(parseAbsoluteToLocal(new Date().toISOString()))}>Start Now</Button>
            </div>
        </div>
    )
}

function formatSecondsToTime(seconds) {
    const days = Math.floor(seconds / 86400);
    seconds %= 86400;
    const hours = Math.floor(seconds / 3600);
    seconds %= 3600;
    const minutes = Math.floor(seconds / 60);
    seconds %= 60;

    const pad = (num) => String(num).padStart(2, '0');

    return `${pad(days)}d ${pad(hours)}h ${pad(minutes)}m ${pad(seconds)}s`;
}

function formatSecondsToTimeNoSeconds(seconds) {
    const days = Math.floor(seconds / 86400);
    seconds %= 86400;
    const hours = Math.floor(seconds / 3600);
    seconds %= 3600;
    const minutes = Math.floor(seconds / 60);

    const pad = (num) => String(num).padStart(2, '0');

    return `${pad(days)}d ${pad(hours)}h ${pad(minutes)}m`;
}